var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000004815(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 9,
    fill: "#FFDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9408 11.462C16.9408 11.462 16.6047 15.6577 16.4117 17.4194C16.4003 17.7887 16.2434 18.1386 15.9752 18.3927C15.7071 18.6469 15.3493 18.7848 14.9799 18.7765H14.9426C13.3178 18.7765 11.6931 18.7765 10.0683 18.7765C9.88712 18.7831 9.7064 18.7539 9.53653 18.6904C9.36667 18.627 9.21102 18.5306 9.07854 18.4068C8.94606 18.283 8.83936 18.1342 8.76457 17.969C8.68979 17.8038 8.6484 17.6255 8.64278 17.4443C8.44358 15.6639 8.10742 11.4807 8.10742 11.4807",
    stroke: "#E50000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8048 9.42371H7.22217",
    stroke: "#E50000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7878 9.42596C15.5507 9.42644 15.3207 9.34488 15.1369 9.1951C14.9531 9.04533 14.8268 8.83656 14.7794 8.60424L14.6299 7.8448C14.5906 7.66908 14.4928 7.51186 14.3526 7.39881C14.2125 7.28577 14.0381 7.22356 13.858 7.22229H11.231C11.0502 7.22327 10.875 7.28526 10.7337 7.39824C10.5925 7.51122 10.4936 7.66857 10.4529 7.8448L10.3035 8.60424C10.2574 8.83605 10.1323 9.04468 9.9495 9.19453C9.76673 9.34438 9.53762 9.42618 9.30127 9.42596",
    stroke: "#E50000",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000004815);
export default __webpack_public_path__ + "static/media/Group 1000004815.c0335982f40d99d060e6e003b13c079c.svg";
export { ForwardRef as ReactComponent };